module.exports = __webpack_public_path__ + "static/media/managers-guide1.1fbdd73c.png";